import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Download = function Download(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.934 2.4343c0-0.51571-0.41855-0.93426-0.93426-0.93426s-0.93426 0.41855-0.93426 0.93426v5.6055h1.8685v-5.6055zm8.0657 17.685c0 1.0319-0.83663 1.8685-1.8685 1.8685h-14.263c-1.0319 0-1.8685-0.83663-1.8685-1.8685v-10.211c0-1.0319 0.83663-1.8685 1.8685-1.8685h6.1972v6.6197l-1.172-1.1716c-0.32933-0.32933-0.85952-0.40967-1.237-0.1378-0.48161 0.34614-0.52131 1.0221-0.12005 1.4229l2.8028 2.8028c0.18218 0.18265 0.42135 0.27374 0.66052 0.27374s0.47834-0.09109 0.66052-0.27374l2.7659-2.7659c0.32979-0.32933 0.41061-0.85952 0.13874-1.2379-0.34567-0.48161-1.0221-0.52131-1.4229-0.12005l-1.208 1.2075v-6.6197h6.1972c1.0319 0 1.8685 0.83663 1.8685 1.8685v10.211z"
  })));
};

Download.displayName = 'Download';
export default Download;